class QuickAddMobile {
  constructor() {
    this.modal = document.getElementById('quick-add-modal-mobile');
    this.init();
    this.currentButton = null;
    this.observer = null;
    this.setupMutationObserver();
  }

  init() {
    if (this.modal) {
      this.modal.querySelectorAll('[data-close-modal]').forEach(btn => {
        btn.addEventListener('click', () => this.close());
      });
    }
  }

  setupMutationObserver() {
    this.observer = new MutationObserver((mutations) => {
      this.checkForNewButtons();
    });

    if (document.body) {
      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  checkForNewButtons() {
    const buttons = document.querySelectorAll('.quick-add-mobile-btn:not([data-quick-add-initialized])');
    if (buttons.length > 0) {
      buttons.forEach(btn => {
        this.setupButton(btn);
      });
    }
  }

  setupButton(btn) {
    btn.setAttribute('data-quick-add-initialized', 'true');
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      try {
        const productData = JSON.parse(btn.dataset.product);
        this.open(productData, btn);
      } catch (error) {
        console.error('Erro ao analisar dados do produto:', error);
      }
    });
  }

  open(product, clickedButton) {
    if (!this.modal) return;
    
    this.currentButton = clickedButton;
    
    const titleElement = this.modal.querySelector('.product-title-modal');
    if (titleElement) {
      const maxLength = 40;
      const titleText = product.title;
      titleElement.textContent = titleText.length > maxLength 
        ? titleText.slice(0, maxLength) + "..." 
        : titleText;
    }
    const imageElement = this.modal.querySelector('.product-image');
    
    try {
      let imageUrl = null;

      if (clickedButton && clickedButton.dataset.image) {
        imageUrl = clickedButton.dataset.image;
      }
      
      if (!imageUrl && clickedButton) {
        const productCard = clickedButton.closest('.product-card, .card, .product, .grid__item, .product-item');
        
        if (productCard) {
          const productImage = productCard.querySelector('img.product-image, img.card__image, img.product__image, img.product-item__image, img');
          
          if (productImage && productImage.src) {
            imageUrl = productImage.src;
          }
        }
      }
      
      if (!imageUrl) {
        const productElements = document.querySelectorAll(`[data-product-id="${product.id}"], [data-product-handle="${product.handle}"]`);
        
        for (const element of productElements) {
          const nearbyImage = element.querySelector('img') || 
                             element.closest('.product-card, .card, .product')?.querySelector('img');
          
          if (nearbyImage && nearbyImage.src) {
            imageUrl = nearbyImage.src;
            break;
          }
        }
      }
      
      if (!imageUrl && product.id) {
        const allImages = document.querySelectorAll('img');
        const productIdStr = String(product.id);
        const titleWords = product.title.toLowerCase().split(' ');
        
        const significantWords = titleWords.filter(word => 
          word.length > 3 && !['com', 'para', 'que', 'dos', 'das', 'por'].includes(word)
        );
        
        for (const img of allImages) {
          const imgSrc = img.src.toLowerCase();
          const imgAlt = (img.alt || '').toLowerCase();
          
          if (imgSrc.includes(productIdStr) || imgAlt.includes(productIdStr)) {
            imageUrl = img.src;
            break;
          }
          
          const matchesTitle = significantWords.some(word => 
            (imgSrc.includes(word) || imgAlt.includes(word)) && 
            !imgSrc.includes('placeholder') && 
            !imgSrc.includes('logo') && 
            !imgSrc.includes('icon')
          );
          
          if (matchesTitle) {
            const parentCard = img.closest('.product-card, .card, .product, .grid__item, .product-item');
            if (parentCard) {
              const cardText = parentCard.textContent.toLowerCase();
              if (cardText.includes(product.title.toLowerCase())) {
                imageUrl = img.src;
                break;
              }
            }
          }
        }
      }

      if (!imageUrl && product.handle) {
        const shopifyDomain = window.location.hostname;
        imageUrl = `https://${shopifyDomain}/cdn/shop/products/${product.handle}.jpg`;
      }

      if (!imageUrl) {
        imageUrl = "/placeholder.svg?height=300&width=300";
      }
      
      if (imageElement) {
        imageElement.src = imageUrl;
        imageElement.onerror = function() {
          this.src = "/placeholder.svg?height=300&width=300";
          this.onerror = null;
        };
      }
    } catch (error) {
      if (imageElement) {
        imageElement.src = "/placeholder.svg?height=300&width=300";
      }
    }
    
    if (imageElement) {
      imageElement.alt = product.title || 'Imagem do produto';
    }
    
    const container = this.modal.querySelector('.size-options-container');
    if (!container) return;
    
    container.innerHTML = '';
    
    const sizeOptionsWrapper = document.createElement('div');
    sizeOptionsWrapper.className = 'size-options-wrapper';
    
    const sizeOptions = document.createElement('div');
    sizeOptions.className = 'size-options size-options-mobile';

    if (product.variants.length > 1) {
      const sizeVariants = new Map();
      
      // Primeiro filtramos apenas as variantes disponíveis
      const availableVariants = product.variants.filter(variant => variant.available);
      
      // Se não houver variantes disponíveis, mostramos uma mensagem
      if (availableVariants.length === 0) {
        const unavailableMessage = document.createElement('p');
        unavailableMessage.className = 'unavailable-message';
        unavailableMessage.textContent = 'Produto indisponível';
        sizeOptions.appendChild(unavailableMessage);
      } else {
        // Mostramos apenas as variantes disponíveis
        availableVariants.forEach(variant => {
          const sizeName = variant.options[0];
          if (!sizeVariants.has(sizeName)) {
            sizeVariants.set(sizeName, variant);
          }
        });
        
        sizeVariants.forEach((variant, sizeName) => {
          const productForm = document.createElement('product-form');
          productForm.dataset.productId = product.id;
          productForm.className = 'product-form product-form-mobile';
          
          const form = document.createElement('form');
          form.method = 'post';
          form.action = '/cart/add';
          form.id = `product_form_${product.id}`;
          form.acceptCharset = 'UTF-8';
          form.className = 'shopify-product-form shopify-product-form-mobile';
          form.enctype = 'multipart/form-data';
          
          const formTypeInput = document.createElement('input');
          formTypeInput.type = 'hidden';
          formTypeInput.name = 'form_type';
          formTypeInput.value = 'product';
          
          const utf8Input = document.createElement('input');
          utf8Input.type = 'hidden';
          utf8Input.name = 'utf8';
          utf8Input.value = '✓';
          
          const idInput = document.createElement('input');
          idInput.type = 'hidden';
          idInput.name = 'id';
          idInput.value = variant.id;
          idInput.dataset.variantId = '';
          
          const button = document.createElement('button');
          button.type = 'submit';
          button.name = 'add';
          button.className = 'size-option size-option-mobile';
          button.dataset.sizeOption = '';
          button.setAttribute('aria-label', `Selecionar tamanho ${sizeName}`);
          
          const labelSpan = document.createElement('span');
          labelSpan.className = 'size-option__label';
          labelSpan.textContent = sizeName;
          
          const loaderSpan = document.createElement('span');
          loaderSpan.className = 'size-option__loader';
          loaderSpan.setAttribute('aria-hidden', 'true');
          
          const productIdInput = document.createElement('input');
          productIdInput.type = 'hidden';
          productIdInput.name = 'product-id';
          productIdInput.value = product.id;
          
          const sectionIdInput = document.createElement('input');
          sectionIdInput.type = 'hidden';
          sectionIdInput.name = 'section-id';
          sectionIdInput.value = 'template--24211045482783__products';
          
          button.appendChild(labelSpan);
          button.appendChild(loaderSpan);
          
          form.appendChild(formTypeInput);
          form.appendChild(utf8Input);
          form.appendChild(idInput);
          form.appendChild(button);
          form.appendChild(productIdInput);
          form.appendChild(sectionIdInput);
          
          productForm.appendChild(form);
          
          sizeOptions.appendChild(productForm);
        });
      }
    } else {
      // Caso de produto com apenas uma variante
      const variant = product.variants[0];
      
      if (variant.available) {
        const productForm = document.createElement('product-form');
        productForm.dataset.productId = product.id;
        productForm.className = 'product-form product-form-mobile';
        
        const form = document.createElement('form');
        form.method = 'post';
        form.action = '/cart/add';
        form.id = `product_form_${product.id}`;
        form.acceptCharset = 'UTF-8';
        form.className = 'shopify-product-form shopify-product-form-mobile';
        form.enctype = 'multipart/form-data';
        
        const formTypeInput = document.createElement('input');
        formTypeInput.type = 'hidden';
        formTypeInput.name = 'form_type';
        formTypeInput.value = 'product';
        
        const utf8Input = document.createElement('input');
        utf8Input.type = 'hidden';
        utf8Input.name = 'utf8';
        utf8Input.value = '✓';
        
        const idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'id';
        idInput.value = variant.id;
        idInput.dataset.variantId = '';
        
        const button = document.createElement('button');
        button.type = 'submit';
        button.name = 'add';
        button.className = 'size-option size-option-mobile';
        button.dataset.sizeOption = '';
        button.setAttribute('aria-label', 'Adicionar ao carrinho');
        
        const labelSpan = document.createElement('span');
        labelSpan.className = 'size-option__label';
        labelSpan.textContent = 'Único';
        
        const loaderSpan = document.createElement('span');
        loaderSpan.className = 'size-option__loader';
        loaderSpan.setAttribute('aria-hidden', 'true');
        
        const productIdInput = document.createElement('input');
        productIdInput.type = 'hidden';
        productIdInput.name = 'product-id';
        productIdInput.value = product.id;
        
        const sectionIdInput = document.createElement('input');
        sectionIdInput.type = 'hidden';
        sectionIdInput.name = 'section-id';
        sectionIdInput.value = 'template--24211045482783__products';
        
        button.appendChild(labelSpan);
        button.appendChild(loaderSpan);
        
        form.appendChild(formTypeInput);
        form.appendChild(utf8Input);
        form.appendChild(idInput);
        form.appendChild(button);
        form.appendChild(productIdInput);
        form.appendChild(sectionIdInput);
        
        productForm.appendChild(form);
        
        sizeOptions.appendChild(productForm);
      } else {
        const unavailableMessage = document.createElement('p');
        unavailableMessage.className = 'unavailable-message';
        unavailableMessage.textContent = 'Produto indisponível';
        sizeOptions.appendChild(unavailableMessage);
      }
    }
    
    sizeOptionsWrapper.appendChild(sizeOptions);
    container.appendChild(sizeOptionsWrapper);
    
    this.modal.hidden = false;
    setTimeout(() => this.modal.classList.add('show'), 10);
    
    setTimeout(() => {
      const sizeOptionsEl = this.modal.querySelector('.size-options-mobile');
      if (sizeOptionsEl) {
        if (sizeOptionsEl.scrollWidth > sizeOptionsEl.clientWidth) {
          sizeOptionsEl.classList.add('has-overflow');
        } else {
          sizeOptionsEl.classList.remove('has-overflow');
        }
      }
    }, 100);
    
    if (typeof window.initProductForms === 'function') {
      window.initProductForms();
    }
  }

  close() {
    if (this.modal) {
      this.modal.classList.remove('show');
      setTimeout(() => this.modal.hidden = true, 300);
    }
  }
}

window.quickAddMobile = new QuickAddMobile();

function setupQuickAddButtons() {
  const buttons = document.querySelectorAll('.quick-add-mobile-btn:not([data-quick-add-initialized])');
  if (buttons.length > 0) {
    buttons.forEach(btn => {
      window.quickAddMobile.setupButton(btn);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setupQuickAddButtons();
  });
} else {
  setupQuickAddButtons();
}